import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Geosuggest from 'react-geosuggest'

import Button from 'components/button'
import TextInput from 'components/setupform-form/field/text-input'

import styles from './venue-search-google.css'

const VenueSearchGoogle = ({
  clearNewVenue,
  handleClear,
  handleSelectVenueSuggestion,
  handleFieldUpdate,
  newVenue,
  newVenueOriginal,
}) => (
  <div styleName="new-input">
    <Geosuggest
      placeholder="Please search via Google for your address"
      onChange={handleClear}
      onSuggestSelect={handleSelectVenueSuggestion}
    />

    {newVenue &&
      <div styleName="address-input">
        <TextInput placeholder="Venue name" data={{ value: newVenue.name, onChange: handleFieldUpdate('name') }} />
      </div>
    }
    {newVenue && !newVenueOriginal.address1 &&
      <div styleName="address-input">
        <TextInput
          placeholder="Address (Street number and/or name)"
          data={{ value: newVenue.address1, onChange: handleFieldUpdate('address1') }}
        />
      </div>
    }
    {newVenue && !newVenueOriginal.city &&
      <div styleName="address-input">
        <TextInput placeholder="City" data={{ value: newVenue.city, onChange: handleFieldUpdate('city') }} />
      </div>
    }
    {newVenue && !newVenueOriginal.postal_code &&
      <div styleName="address-input">
        <TextInput
          placeholder="Postcode or Zipcode"
          data={{ value: newVenue.postal_code, onChange: handleFieldUpdate('postal_code') }}
        />
      </div>
    }

    <div styleName="cancel"><Button text="Go back to venue search" type="utility" onClick={clearNewVenue} /></div>
  </div>
)

VenueSearchGoogle.propTypes = {
  clearNewVenue: PropTypes.func,
  handleClear: PropTypes.func,
  handleFieldUpdate: PropTypes.func,
  handleSelectVenueSuggestion: PropTypes.func,
  newVenue: PropTypes.object,
  newVenueOriginal: PropTypes.object,
  venueAddressData: PropTypes.object,
  venueNameData: PropTypes.object,
}

export default CSSModules(VenueSearchGoogle, styles)




/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/venue-search/venue-search-google/venue-search-google.js
 **/